import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cn } from "../utils"

export type LabelProps = React.ComponentPropsWithoutRef<
  typeof LabelPrimitive.Root
>

export const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  LabelProps
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      "text-[13px] font-semibold text-foreground leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      className
    )}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName
